function mergeObjects(objTo, objFrom) {
    for (var key in objFrom) {
        objTo[key] = objFrom[key];
    }
    return objTo;
}

function ajaxErrorCallback(jqXHR, btn) {
    if (typeof btn !== 'undefined') {
        $(btn).button('reset');
    }

    var response = JSON.parse(jqXHR.responseText);
    if (response) {
        if (response.errors && response.errors.length) {
            return notify.error(response.errors[0]);
        }
    }
    notify.error(jqXHR.responseText);
}
